import { render, staticRenderFns } from "./mallOrderDetail.vue?vue&type=template&id=194ad28f&scoped=true&"
import script from "./mallOrderDetail.vue?vue&type=script&lang=js&"
export * from "./mallOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./mallOrderDetail.vue?vue&type=style&index=0&id=194ad28f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194ad28f",
  null
  
)

export default component.exports